import React, { useRef,useState,useEffect } from 'react';
import WhoWeAreStyles from '../../styles/AboutUs/WhoWeAre.module.css';
import { FaLongArrowAltRight,FaLongArrowAltLeft } from "react-icons/fa";

import image from '../../assets/WhatsApp Image 2025-08-07 at 18.30.25_cc7fb72e.jpg'

const WhoWeAre = () => {

    const slides = [
        {
          title: "Core Purpose",
            content: `Our core of being in this world is “To improve the life of people and serve communities by providing knowledge and alternative solutions with an endeavour to create more equitable, just and sustainable society.`,
        },
        {
          title: "Our Vision",
          content: `To be a leading global company in Securing Sustainable Future for humanity. Our vision is to be a global company in securing a sustainable future by accelerating the implementation of sustainable development goals in an integrated manner through shared value and action-oriented programmes.`,
        },
        {
          title: "Our Mission",
          content: `Our mission is to contribute in achievements of goals of action oriented programmes focusing on implementation of sustainable development agenda. Our mission will remain global in our action-oriented goals and in partnerships to enhance the effectiveness of programme through exchange of knowledge, solutions and resources.`,
        },
      ];

    const scrollRef = useRef(null);

    const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  const checkScroll = () => {
    const el = scrollRef.current;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight((el.scrollLeft+el.scrollWidth) >= el.scrollWidth);
  };

  useEffect(() => {
    const el = scrollRef.current;
    checkScroll();
    el.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    return () => {
        el.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
    };
  }, []);

  return (
    <section className={WhoWeAreStyles.container}>
      <p className={WhoWeAreStyles.label}>— Who We Are</p>
      <h2 className={WhoWeAreStyles.heading}>
        <span className={WhoWeAreStyles.orange}>What We Stand For </span> <br/>
        <span className={WhoWeAreStyles.dark}>Defines What We Build</span>
      </h2>
      <p className={WhoWeAreStyles.description}>
        At GreenWork Consulting, we are a team of dedicated professionals committed to delivering innovative solutions that drive sustainability and efficiency. 
      </p>

      <div className={WhoWeAreStyles.content}>
        {/* Left */}
        <div className={WhoWeAreStyles.imageBox}>
          <img
            src={image}
            alt="Handshake"
            className={WhoWeAreStyles.image}
          />
          {/* <div className={WhoWeAreStyles.experienceBadge}>
            <span>25+</span>
            <small>Years of Experience</small>
          </div> */}
        </div>

        {/* Right */}
        <div className={WhoWeAreStyles.missionBox} >

            <div className={WhoWeAreStyles.sliderContainer} ref={scrollRef}>
                {slides.map((slide, index) => (
                <div key={index} className={WhoWeAreStyles.slide}>
                    <h3 className={WhoWeAreStyles.missionHeading} >{slide.title}</h3>
                    <p>{slide.content}</p>
                </div>
                ))}
            </div>

            <div className={WhoWeAreStyles.cardBottom}>
                <div className={WhoWeAreStyles.footer}>
                <span
                    className={`${WhoWeAreStyles.circle} ${
                    canScrollLeft ? WhoWeAreStyles.orangeCircle : WhoWeAreStyles.darkCircle
                    }`}
                    onClick={canScrollLeft ? scrollLeft : null}
                >
                    <FaLongArrowAltLeft size={10} />
                </span>
                <span
                    className={`${WhoWeAreStyles.circle} ${
                    canScrollRight ? WhoWeAreStyles.orangeCircle : WhoWeAreStyles.darkCircle
                    }`}
                    onClick={canScrollRight ? scrollRight : null}
                >
                    <FaLongArrowAltRight size={10} />
                </span>
                </div>
            </div>

          {/* <div className={WhoWeAreStyles.cardBottom}>
            <div className={WhoWeAreStyles.footer}>
                <span 
                    className={`${WhoWeAreStyles.darkCircle}`}
                    onClick={scrollLeft} 
                >
                    <FaLongArrowAltLeft size={10} />
                </span>
                <span 
                    className={WhoWeAreStyles.orangeCircle} 
                    onClick={scrollRight} 
                >
                    <FaLongArrowAltRight size={10} />
                </span>
            </div>
          </div> */}
        </div>
        
      </div>
    </section>
  );
};

export default WhoWeAre;
